import { chooseBestFit, extractSizes } from 'wordpress/components'

import * as defaultBackground from '../../home/assets/metro.jpg'

const MenuItem = ({ name, path }) => (
    <li>
        <Link navLink exact to={path} activeClassName={'active'}>
            <T>{name}</T>
        </Link>
    </li>
)

export const Menu = ({ items }) => (
    <ul className="menu">{items.map(item => item && <MenuItem {...item} key={item.name} />)}</ul>
)

const Header = ({ background, menuItems, hasMenu }) => (
    <div
        className="dashboard-header"
        style={{
            backgroundImage: `url(${background ? chooseBestFit(extractSizes(background)) : defaultBackground}`,
        }}>
        <div className="dashboard-inner-container">{hasMenu && <Menu items={menuItems} />}</div>
    </div>
)

export default Header
